// document.querySelectorAll('.has-dropdown').forEach(item => {
//     item.addEventListener('mouseenter', function () {
//         this.querySelector('.mega-menu').style.display = 'block';
//     });

//     item.addEventListener('mouseleave', function () {
//         this.querySelector('.mega-menu').style.display = 'none';
//     });
// });
// document.addEventListener('DOMContentLoaded', () => {
//     const menuItems = document.querySelectorAll('.header-menu__item');

//     menuItems.forEach((menuItem) => {
//         const button = menuItem.querySelector('.mm-btn');
//         if (button) {
//             button.addEventListener('click', (e) => {
//                 e.preventDefault();

//                 // Toggle the "open" class on the current item
//                 menuItem.classList.toggle('open');

//                 // Optionally close other open menus
//                 menuItems.forEach((item) => {
//                     if (item !== menuItem) {
//                         item.classList.remove('open');
//                     }
//                 });
//             });
//         }
//     });
// });
document.addEventListener('DOMContentLoaded', () => {
    const mobileNav = document.querySelector('#mobile-nav');

    if (!mobileNav) return; // Exit if the mobile nav does not exist

    const menuItems = mobileNav.querySelectorAll('.header-menu__item');

    menuItems.forEach((menuItem) => {
        const button = menuItem.querySelector('.mm-btn');
        if (button) {
            button.addEventListener('click', (e) => {
                e.preventDefault();

                // Toggle the "open" class on the current item
                const isOpen = menuItem.classList.toggle('open');

                // Close other open menus if the current one is being opened
                if (isOpen) {
                    menuItems.forEach((item) => {
                        if (item !== menuItem) {
                            item.classList.remove('open');
                        }
                    });
                }
            });
        }
    });
});


// document.addEventListener('DOMContentLoaded', () => {

//     const menus = document.querySelectorAll('.header-menu__item');
//     menus.forEach(menu => {
//         const megaMenu = menu.querySelector('.mega-menu');

//         if (megaMenu) {
//             menu.addEventListener('mouseenter', () => {
//                 const rect = megaMenu.getBoundingClientRect();
//                 const viewportWidth = window.innerWidth;

//                 // Reset transform for recalculation
//                 megaMenu.style.transform = 'translateX(0)';

//                 // Adjust left if the menu overflows to the right
//                 if (rect.right > viewportWidth) {
//                     const overflowRight = rect.right - viewportWidth;
//                     megaMenu.style.transform = `translateX(-${overflowRight}px)`;
//                 }

//                 // Adjust left if the menu overflows to the left
//                 if (rect.left < 0) {
//                     const overflowLeft = Math.abs(rect.left);
//                     megaMenu.style.transform = `translateX(${overflowLeft}px)`;
//                 }
//             });
//         }
//     });
// });
